module.exports = __webpack_public_path__ + "static/media/outsign.0a225763.jpg";